// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".financial-reports[data-v-4fcb02e4] {\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
module.exports = exports;
